/** @format */
'use client';
import BellIcon from '@/app/[locale]/ui/BellIcon';
import NotificationBadge from '@atoms/NotificationBadge';
import { Notification } from '@common/model/apiClient/Notification';

import NotificationMenu from '@molecules/NotificationMenu';
import { useQuery } from '@tanstack/react-query';
import Popover from 'devextreme-react/popover';
import { useSession } from 'next-auth/react';
import React, { useRef } from 'react';
import styled from 'styled-components';
import styles from './NotificationButton.module.css';

interface NotificationButtonProps {}

const ButtonWrapper = styled.span`
  cursor: pointer;
  position: relative;
  > svg {
    display: block;
    height: 32px;
    width: 32px;
  }
`;

function NotificationButton(props: NotificationButtonProps) {
  const { data: session } = useSession();
  const btnRef = useRef<HTMLDivElement>(null);
  const notifications = useQuery({
    queryKey: [session?.user?.userId, 'user_notification_query'],
    queryFn: () => Notification.list(session?.user?.userId!),
    enabled: !!session?.user?.userId,
    refetchOnWindowFocus: true,
    refetchInterval: 60 * 1000,
    placeholderData: (previousData) => previousData,
  });

  const notificationCount = (notifications.data?.payload ?? []).filter((n) => !n.read).length;

  const button = () => (
    <div className={styles.btn}>
      {/*<BellIcon animate={false} />*/}
      <BellIcon animate={!!notificationCount} />
      {!!notificationCount && <NotificationBadge notificationCount={notificationCount} />}
    </div>
  );

  return (
    <div>
      <div className={styles.btn} ref={btnRef}>
        {/*<BellIcon animate={false} />*/}
        <BellIcon animate={!!notificationCount} />
        {!!notificationCount && <span className={styles.badge}>{Math.min(notificationCount, 99)}</span>}

        {/*{!!notificationCount && <NotificationBadge notificationCount={notificationCount} />}*/}
      </div>
      <Popover target={btnRef.current!} showEvent={'click'}>
        <NotificationMenu notifications={notifications.data?.payload} />
      </Popover>
    </div>
  );
}

export default NotificationButton;
